

















































































































































































































































































































































































































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import ModalTabs, { TabItem } from "@/components/root/modal/ModalTabs.vue";
import LevelLabel from "@/components/LevelLabel.vue";
import { ModalConfig } from "@/components/root/modal";
import { ref, computed, onMounted } from "@vue/composition-api";
import { getEmailAddressFromExtendedData } from "@/gql/types";
import { SharedState } from "@/common/state";
import { InfoTypeHelper, POPULATION_TYPE } from "@/common/models";
import { AppAnalytics } from "@/analytics";
import { identity, uniqby, uniq_by_keys } from "@/fp";
import EmptyCell from "../EmptyCell.vue";
import { EmployeesHelper } from "@/common/entities/helpers";
import RiskCard from "@/views/customize/in-motion/risk-types/RiskCard.vue";
import { sortBy } from "@/fp";
import SpiMarker from "../SpiMarker.vue";
import { getInfoType } from "@/common/state/infotypes";
import { FileModelHelper } from "@/gql/file-parser";
import { CopyUrl } from "@/common/clipboard";
export default Vue.extend({
  name: "EventDetailsLegacyModal",
  components: {
    Modal,
    ModalTabs,
    LevelLabel,
    EmptyCell,
    RiskCard,
    SpiMarker,
  },
  props: ["modalData"],
  setup(props: any, { emit, root: { $router } }: any) {
    const feature_pii = SharedState.FeatureHelper.is_enabled("pii_labeler");
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: feature_pii ? "82rem" : "60rem",
      height: "50rem",
      withTopRightCloseBtn: true,
    };

    const PII_LABELS_CATEGORY_TO_HIDE = [
      "MIP Labels",
      "Virtual",
      "Has MIP Label",
      "External Information",
      "Internal Information",
    ];

    const featureTopics = computed(
      () => SharedState.loggedUser.value.paymentEdition.topics
    );
    // files
    const files = computed(() => {
      const eventItems = ((props.modalData as any).item.items || []) as any[];
      const archiveNameToFiles = eventItems.reduce(
        (acc, item) => {
          const archiveName = item?.archive?.archiveName;
          if (archiveName && item?.name) {
            if (!acc[archiveName]) {
              acc[archiveName] = [];
            }
            acc[archiveName].push(item.name);
          }
          return acc;
        },
        {} as Record<string, string[]>
      );

      return eventItems.map((file: any) => {
        console.log("file::", file);

        const info_label_id = file?.labels?.infoLabel?.id;
        const info_label = info_label_id
          ? SharedState.getInfoType(info_label_id)
          : undefined;
        // @ts-ignore
        const info_label_path = Array.isArray(info_label?.path)
        // @ts-ignore
          ? (info_label?.path as any[])
          : [];
        const info_label_tree = info_label_path
          .map((id: any) => SharedState.getInfoType(id))
          .filter(Boolean)
          // @ts-ignore
          .map((label) => label.labelName);

        const ctxLabels = Array.isArray(file?.labels?.ctxLabels)
          ? file.labels.ctxLabels
          : [];
        const piisLabels = Array.isArray(file?.labels?.piis)
          ? file.labels.piis
          : [];
        const archiveItemsRaw = Array.isArray(file?.internalItems)
          ? file.internalItems
              .filter((d: any) => d && d.name)
              .map((d: any) => d.name)
          : [];
        const fallbackArchiveItems =
          file?.archive?.archiveName &&
          archiveNameToFiles[file.archive.archiveName]
            ? [...archiveNameToFiles[file.archive.archiveName]]
          : [];
        const archiveItemsSource =
          archiveItemsRaw.length > 0
            ? archiveItemsRaw
            : fallbackArchiveItems;
        // Keep physical occurrences as-is to align count with extracted items.
        const archive_items = archiveItemsSource;

        return {
          ...file,
          is_email_body: FileModelHelper.is_email_body(file),
          context: ctxLabels.map((d: any) => d.name).join(", "),
          content_label: {
            ...file?.labels?.infoLabel,
            tree:
              info_label_tree.length > 0
                ? info_label_tree.slice(0, info_label_tree.length - 1)
                : [],
            labelName:
              info_label?.labelName || file?.labels?.infoLabel?.name || "",
          },
          piis: piisLabels.filter((d: { labelCategory: string }) =>
            PII_LABELS_CATEGORY_TO_HIDE.includes(d.labelCategory)
              ? false
              : true
          ),
          archive_items,
          topic: file?.extendedProperties ? file.extendedProperties.topic : "",
        };
      });
    });

    const event_insights = computed(() =>
      uniq_by_keys(
        "shareType",
        "sensitivity"
      )(
        (props.modalData as any).item.insights
          .filter((l: any) => {
            const ins = SharedState.indexed_insights.value[l.id];
            if (!ins) return false;
            return ins.infoTypeId;
          })
          .map((l: any) => SharedState.indexed_insights.value[l.id])
      )
    );

    const event_severity_insights = computed(() =>
      event_insights.value.filter(
        // @ts-ignore
        (ins) => ins.severityLevel === props.modalData.item.severity
      )
    );

    const other_event_insights = computed(() =>
      sortBy(
        event_insights.value.filter(
          // @ts-ignore
          (ins) => ins.severityLevel !== props.modalData.item.severity
        ),
        "severityLevel",
        true
      )
    );

    const tabs = computed(() => {
      // @ts-ignore
      const { exposedTo } = props.modalData.item;
      return [
        {
          name: "Summary",
          icon: "Summary",
        },
        {
          name: "Content",
          icon: "File",
          count: files.value.length,
        },
        {
          name: "Entities",
          icon: "User",
          count: exposedTo.length + 1,
        },
        {
          name: "Risks",
          icon: "Events",
          count: event_insights.value.length || 0,
        },
      ] as TabItem[];
    });

    // The risk indicator opens the modal with section "Overview" (the new
    // modal's first tab). The legacy modal has no "Overview" tab, so map it to
    // "Summary" and fall back to "Summary" for any unrecognized section to
    // avoid rendering a blank body.
    const sectionToTab = (section: string): string => {
      const valid = ["Summary", "Content", "Entities", "Risks"];
      return valid.includes(section) ? section : "Summary";
    };
    // @ts-ignore
    const selectedTabName = ref(sectionToTab(props.modalData.section));

    const invEntity = async (entity: any) => {
      AppAnalytics.report({
        component: "General",
        eventName: `user presed a person to investigate in EventRowDetailsModal in page :${$router.currentRoute.name}`,
      });

      let type;
      switch (entity.type) {
        case "organization":
          type = POPULATION_TYPE.ORGANIZATION;
          break;
        case "person":
        default:
          type = entity.isExternal
            ? POPULATION_TYPE.CONTACT
            : POPULATION_TYPE.EMPLOYEE;
          break;
      }

      emit("submit", {
        action: "investigate",
        payload: {
          ...entity,
          type,
        },
      });
    };

    const goToCluster = async (file: any) => {
      AppAnalytics.report({
        component: "General",
        eventName: `user presed a file to investigate in EventRowDetailsModal in page :${$router.currentRoute.name}`,
      });
      emit("submit", {
        action: "investigate",
        payload: {
          ...file,
          cluster_id: file.clusterUID,
          type: POPULATION_TYPE.FILE,
        },
      });
    };

    onMounted(() => {
      console.log("eventRowDetails:", props.modalData);
      AppAnalytics.report({
        component: "General",
        eventName: `user opened EventRowDetailsModal in page :${$router.currentRoute.name}`,
      });
    });

    const decodeUriSafe = (value: string) => {
      try {
        return decodeURIComponent(value);
      } catch {
        return value;
      }
    };

    const truncateMiddle = (
      value: string,
      maxLength = 110,
      suffixLength = 45
    ) => {
      if (!value || value.length <= maxLength) {
        return value;
      }
      const dots = "...";
      const normalizedSuffixLength = Math.min(
        suffixLength,
        Math.max(1, maxLength - dots.length - 1)
      );
      const prefixLength = maxLength - dots.length - normalizedSuffixLength;
      return `${value.slice(0, prefixLength)}${dots}${value.slice(
        -normalizedSuffixLength
      )}`;
    };

    const appendFileNameToUrl = (url: string, fileName: string) => {
      if (!url) return "";
      if (!fileName) return url;

      const decodedUrl = decodeUriSafe(url);
      const decodedFileName = decodeUriSafe(fileName);
      if (
        decodedUrl.endsWith(`/${decodedFileName}`) ||
        decodedUrl.endsWith(decodedFileName)
      ) {
        return url;
      }

      const [baseAndQuery, hash = ""] = url.split("#");
      const [basePath, query = ""] = baseAndQuery.split("?");
      const normalizedBasePath = basePath.replace(/\/+$/, "");
      const normalizedFileName = fileName.replace(/^\/+/, "");
      const urlWithFileName = `${normalizedBasePath}/${normalizedFileName}`;

      return `${urlWithFileName}${query ? `?${query}` : ""}${
        hash ? `#${hash}` : ""
      }`;
    };

    // File URL for the Content tab header
    const fileUrl = computed(() => {
      const item = (props.modalData as any).item;
      const firstFile = item.items?.[0];
      const baseUrl = item.file_upload_path || firstFile?.path || "";
      const fileName = firstFile?.name || "";
      return appendFileNameToUrl(baseUrl, fileName);
    });

    // Decoded URL for display (replaces %20 with spaces, etc.)
    const fileUrlDisplay = computed(() => {
      try {
        return decodeURIComponent(fileUrl.value as unknown as string);
      } catch {
        return fileUrl.value;
      }
    });

    const fileUrlDisplayTruncated = computed(() =>
      truncateMiddle(fileUrlDisplay.value as string)
    );

    const copyFileUrl = () => {
      CopyUrl(fileUrl.value, 'URL copied to clipboard');
    };

    return {
      feature_pii,
      config,
      selectedTabName,
      tabs,
      files,
      event_insights,
      event_severity_insights,
      other_event_insights,
      featureTopics,
      goToCluster,
      invEntity,
      fileUrl,
      fileUrlDisplay,
      fileUrlDisplayTruncated,
      copyFileUrl,
    };
  },
});
